import schemas from "@/utils/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { useResetPassword } from "./hooks";
import { Button, Input } from "@aidergroup/ui-v2";
import { Styled } from "./styles";
import useUser from "@/context/user";
import { useNavigate } from "react-router-dom";
import { i18n } from "@/utils/i18n";
import useLocale from "@/context/locale";

const Form: React.FC = () => {
    useLocale(state => state.locale);
    const email = useUser(state => state.email);
    const navigate = useNavigate();

    const { handleSubmit, control, formState } = useForm({
        resolver: yupResolver(schemas.resetPassword),
        defaultValues: { email: email ?? "" },
    });

    const { isLoading, isSubmitting, isValidating } = formState;

    const onReset = useResetPassword();

    return (
        <Styled.Container>
            <form onSubmit={handleSubmit(async form => await onReset(form))}>
                <Input
                    label={i18n.t("label.email")}
                    name="email"
                    type="email"
                    placeholder={i18n.t("placeholder.email")}
                    control={control}
                    labelStyle={{ color: "white" }}
                />
                <Button
                    variant="contained"
                    type="submit"
                    fullWidth={true}
                    disabled={isLoading || isSubmitting || isValidating}
                    loading={isLoading || isSubmitting}
                    sx={{ margin: "5px 0px" }}
                >
                    {i18n.t("button.reset")}
                </Button>
                <Button
                    onClick={() => navigate("/sign-in")}
                    fullWidth={true}
                    variant="outlined"
                    sx={{ margin: "5px 0px" }}
                    disabled={isLoading || isSubmitting || isValidating}
                >
                    {i18n.t("button.signIn")}
                </Button>
            </form>
        </Styled.Container>
    );
};

export default Form;
